import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import App from "./pages/App";
import DocumentSynchroniserProvider from "./providers/DocListSynchroniser";
import { SnackbarProvider } from "notistack";
import { AppConfigurationProvider } from "./providers/AppConfiguration";
import { SearchIndexProvider } from "./providers/SearchIndex";
import { processDirectLink } from "./directLink";
import { handleLoginRedirect } from "./providers/jwt";
import { FileDownloadStatusProvider } from "./providers/FileDownloader";

// Handle Okta Auth redirects as early as possible (no rendering at all)
if (!handleLoginRedirect()) {
  // Special Handler for Direct document links.
  if (document.location.pathname.startsWith("/app/docs/")) {
    processDirectLink(document.location.pathname.substring(4));
  } else {
    window.onerror = (a, b, c, d, e) => {
      console.log(`App Error: ${a}\nsource: ${b}\nlineno: ${c}\ncolno: ${d}\nerror: ${e}`);
      return true;
    };


    const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
    root.render(
      <ThemeProvider theme={theme}>
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline />
        <AppConfigurationProvider>
          <DocumentSynchroniserProvider>
            <FileDownloadStatusProvider>
              <SearchIndexProvider>
                <SnackbarProvider disableWindowBlurListener>
                  <App />
                </SnackbarProvider>
              </SearchIndexProvider>
            </FileDownloadStatusProvider>
          </DocumentSynchroniserProvider>
        </AppConfigurationProvider>
      </ThemeProvider>
    );

    // If you want to start measuring performance in your app, pass a function
    // to log results (for example: reportWebVitals(console.log))
    // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
    reportWebVitals();
  }
}
